import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Toggle({ id, Text, Type, Selected, onClick }) {
    const UI = useContext(Context_UI);
    const Handle_Click = () => {
        UI.Buttons_Toggle(id);
        if (onClick) {
            onClick(UI.Element_Attribute_Get(id, "State") === "Active" ? true : false);
        }
    }
    return (
        <>
            {Type == null ?
                <button className="Toggle" Fill_Horizontal onClick={Handle_Click} id={id} State={Selected == "true" ? "Active" : "Inactive"} isActive={Selected == "true" ? "true" : "false"}>
                    <div className="Toggle_Switch">
                        <div className="Toggle_Switch_Head"></div>
                    </div>
                    <p className="Toggle_Text">
                        {Text}
                    </p>
                </button>
                :
                <>
                    {Type == "Switch" ?
                        <button className="Toggle" Style="Style_Switch" Fill_Horizontal onClick={Handle_Click} id={id} State={Selected == "true" ? "Active" : "Inactive"} isActive={Selected == "true" ? "true" : "false"}>
                            <div className="Toggle_Switch">
                                <div className="Toggle_Switch_Head"></div>
                            </div>
                            <p className="Toggle_Text">
                                {Text}
                            </p>
                        </button>
                        :
                        ""
                    }
                </>
            }
        </>

    )
}

